import { ComponentProps } from 'react'

import type { TRoomDetail } from '@/entities/room'
import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui'

import { Discounts } from '../common'

type Props = ComponentProps<'details'> &
  Pick<TRoomDetail, 'longTermDiscounts' | 'earlyCheckinDiscounts'>

export const DiscountInformation = ({
  longTermDiscounts,
  earlyCheckinDiscounts,
  className,
  ...restProps
}: Props) => {
  const hasLongTermDiscount = longTermDiscounts.length > 0
  const hasEarlyCheckinDiscount = earlyCheckinDiscounts.length > 0

  const hasNoDiscount = !hasLongTermDiscount && !hasEarlyCheckinDiscount
  const hasAllDiscount = hasLongTermDiscount && hasEarlyCheckinDiscount

  if (hasNoDiscount) {
    return null
  }

  const maxLongTermDiscountRate = longTermDiscounts.at(-1)?.discountRate || null // 기간이 늘어날수록 더 큰 할인율 적용
  const maxEarlyCheckinDiscountAmount =
    earlyCheckinDiscounts[0]?.discountAmount || null // 빨리 입주할수록 더 큰 할인 금액 적용

  return (
    <details className={cn('group px-6', className)} {...restProps}>
      <summary className="flex cursor-pointer list-none gap-1 select-none">
        <dl className="typo-label1 flex w-full items-center justify-between gap-3">
          <dt className="font-normal text-gray-500">할인</dt>
          <dd className="flex items-center gap-2">
            {hasLongTermDiscount && (
              <div
                className={cn('flex items-center', {
                  "after:block after:w-[11px] after:text-center after:text-xs after:font-extralight after:text-purple-300 after:content-['|']":
                    hasAllDiscount,
                })}
              >
                <span className="mr-1 block font-normal text-gray-900">
                  장기계약
                </span>
                <span className="mr-2 block font-semibold text-black">
                  ~{maxLongTermDiscountRate}%{' '}
                </span>
              </div>
            )}
            {hasEarlyCheckinDiscount && (
              <div className="space-x-1">
                <span className="font-normal text-gray-900">즉시입주</span>
                <span className="font-semibold text-black">
                  ~{maxEarlyCheckinDiscountAmount}만 원
                </span>
              </div>
            )}
          </dd>
        </dl>
        <Icon
          name="arrow-bottom"
          size={18}
          className="text-black transition-transform duration-200 group-open:rotate-180"
        />
      </summary>

      <Discounts
        longTermDiscounts={longTermDiscounts}
        earlyCheckinDiscounts={earlyCheckinDiscounts}
        className="mt-2.5"
      />
    </details>
  )
}
